export default __webpack_public_path__ + "static/media/tool.323a64cd.svg";